import {mapRunningTime} from '@domain/shared'
import {type OperationHoursDrawerStoppageData} from '@widgets/running-times'

import {type StoppageDataDto} from '../types'

export const mapStoppageData = (
  stoppageData: StoppageDataDto,
  timezone: string
): OperationHoursDrawerStoppageData => ({
  ...stoppageData,
  runningTime: mapRunningTime(stoppageData.runningTime, timezone)
})
